if (!customElements.get('canvoil-custom-size')) {
  customElements.define('canvoil-custom-size', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const section = document.getElementById(this.dataset.section);
      const trigger = this.querySelector('[data-quote-open]');
      const dialog = this.querySelector('dialog');
      const variants = JSON.parse(this.querySelector('[data-quote-variants]').textContent);
      this.trigger = trigger;
      const place = () => {
        const legend = section.querySelector('.globo-swatch-product-detail .name-option[data-name="Size" i]');
        const dropdown = legend?.nextElementSibling;
        if (dropdown?.matches('.dropdown-selector') && dropdown.nextElementSibling !== trigger) dropdown.after(trigger);
      };
      place();
      this.observer = new MutationObserver(place);
      this.observer.observe(section, {childList:true, subtree:true});
      trigger.addEventListener('click', () => {
        const id = section.querySelector('form[action*="/cart/add"] [name="id"]')?.value || new URL(location.href).searchParams.get('variant');
        const variant = variants.find(v => String(v.id) === String(id)) || variants[0];
        if (variant) {
          this.querySelector('[data-quote-current]').textContent = variant.title;
          const selection = this.querySelector('[data-quote-selection]');
          if (selection) selection.value = variant.title;
          const frame = this.querySelector('[data-quote-frame]');
          if (frame) frame.value = variant.options[Number(frame.dataset.optionIndex)];
          const productUrl = this.querySelector('[data-quote-url]');
          if (productUrl) { const url = new URL(productUrl.value); url.searchParams.set('variant', variant.id); productUrl.value = url.href; }
        }
        dialog.showModal();
      });
      this.querySelector('[data-quote-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger.focus());
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
      const result = this.querySelector('[data-quote-result]');
      if (result) { dialog.showModal(); result.focus(); }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.trigger?.remove(); }
  });
}
